var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMemberTalk(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#61D81D;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31_2.\\u767D\\u7248-\\u6703\\u54E1\\u9078\\u55AE",
    transform: "translate(-203.000000, -480.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "button",
    transform: "translate(193.000000, 470.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(10.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "st0",
    d: "M21.1,30.3c-3,0-5.6-2.5-5.6-5.6s2.5-5.6,5.6-5.6s5.6,2.5,5.6,5.6C26.7,27.8,24.2,30.3,21.1,30.3 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    className: "st1",
    d: "M26.3,12.7c1.3,0,2.4,1.1,2.4,2.4v7.7c0,1.3-1.1,2.4-2.4,2.4h-7.6l-5,3.5v-3.5 c-1.3,0-2.4-1.1-2.4-2.4v-7.7c0-1.3,1.1-2.4,2.4-2.4H26.3z M27.7,22.8v-7.7c0-0.8-0.6-1.4-1.4-1.4H13.7c-0.8,0-1.4,0.6-1.4,1.4 v7.7c0,0.8,0.6,1.4,1.4,1.4h1v2.6l3.7-2.6h7.9C27.1,24.1,27.7,23.5,27.7,22.8z M16,16.3h8.1v1H16V16.3z M16,18.4h8.1v1H16V18.4z  M16,20.6h8.1v1H16V20.6z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMemberTalk);
export default __webpack_public_path__ + "static/media/icon-member-talk.b7b7d0aba5a3ba4434cfa8c8eb313e8d.svg";
export { ForwardRef as ReactComponent };